import axios from 'axios';

// Use explicit env override in prod; otherwise default to local dev backend
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

let accessToken = null;

export const setAccessToken = (token) => {
  accessToken = token;
};

export const getAccessToken = () => accessToken;

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
});

if (typeof window !== 'undefined') {
  // Debug helper to verify which baseURL is used in the browser
  // eslint-disable-next-line no-console
  console.log('🔗 API baseURL:', API_BASE_URL);
}

api.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    // Handle token expiration
    if (error.response?.status === 401) {
      // Clear expired token
      accessToken = null;
      if (typeof window !== 'undefined') {
        localStorage.removeItem('crewmate_token');
        localStorage.removeItem('crewmate_user');
        // Redirect to login or refresh page
        console.log('🔒 Token expired, clearing authentication...');
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;


